import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../html/element'
import { selectScore } from '../../../../store/sliceScoreLevel'
import { getCurrentTime } from '../../../helper'
import classes from '../scoreLevel.module.scss'
import { CustomScore } from './CustomScore'
import { TranscriptItem } from './TranscriptItem'

const styleRight = {
  borderRightColor: '#9C9C9C',
  borderRightWidth: '1px',
  borderRightStyle: 'solid',
}

export const Transcript = ({ data, isRight, typePeriod, typePeriodTime }) => {
  const listSelectStr = useSelector(
    selectScore([typePeriod, typePeriodTime, 'custom'], (data) => {
      let list = {}
      Object.keys(data)
        .filter((key) => data[key] !== undefined)
        .forEach((item) => {
          list[item] = data[item]
        })
      const keyUnique = getCurrentTime()
      const listFormat = Object.keys(list).length
        ? list
        : { [keyUnique]: { From: undefined, To: undefined } }
      return JSON.stringify(listFormat)
    }),
  )
  const listSelect = JSON.parse(listSelectStr)

  const listIdSelectFiinGate = useSelector(
    selectScore([typePeriod, typePeriodTime, 'fiinGate']),
  )
  const listValueSelected = Object.values(listIdSelectFiinGate)
  const disable =
    listValueSelected.length === data.length &&
    !listValueSelected.some((item) => !item)

  //Actions
  return (
    <div className={classes.group} style={isRight ? {} : { ...styleRight }}>
      <div
        style={{
          marginRight: !isRight ? 12 : 0,
          marginLeft: isRight ? 12 : 0,
        }}
      >
        <div style={{ paddingBottom: 8 }}>
          <Element
            elementName="p"
            style={{ fontHeight: '16px', fontWeight: 600 }}
          >
            <Translate
              value={
                isRight
                  ? 'library.filterSetting.PREVIOUS_SCORE'
                  : 'library.filterSetting.CURRENT_SCORE'
              }
            />
          </Element>
        </div>
        <Element
          style={{
            backgroundColor: ' #F3F3F3',
            borderRadius: 2,
          }}
          className={classes.groupScore}
        >
          <Element
            elementName="p"
            style={{
              fontWeight: 600,
            }}
          >
            <Translate value="library.filterSetting.FIINGATE_LEVEL" />
          </Element>
          <div className={classes.groupAction}>
            {data?.map((item, index) => (
              <TranscriptItem
                key={index}
                item={item}
                typePeriod={typePeriod}
                typePeriodTime={typePeriodTime}
              />
            ))}
          </div>
        </Element>
        <Element
          style={{
            paddingBottom: 6,
            paddingTop: 8,
            marginTop: 8,
            backgroundColor: ' #F3F3F3',
            borderRadius: 2,
          }}
        >
          {Object.keys(listSelect).map((item, index) => (
            <CustomScore
              typePeriod={typePeriod}
              typePeriodTime={typePeriodTime}
              item={listSelect[item]}
              keyId={item}
              key={index}
              listSelect={listSelect}
              disable={disable}
              isFirst={index === 0}
            />
          ))}
        </Element>
      </div>
    </div>
  )
}

Transcript.propTypes = {
  data: PropTypes.array,
  isRight: PropTypes.bool,
}
Transcript.defaultProps = {
  isRight: false,
}
